import { render, staticRenderFns } from "./ViewScorecard.vue?vue&type=template&id=652c7f43&scoped=true"
import script from "./ViewScorecard.vue?vue&type=script&lang=js"
export * from "./ViewScorecard.vue?vue&type=script&lang=js"
import style0 from "./ViewScorecard.vue?vue&type=style&index=0&id=652c7f43&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652c7f43",
  null
  
)

export default component.exports